import { useContext } from "react";
import { Navigate, Route, Routes } from "react-router";
import Login from "../../pages/login/Login";
import { GlobalContext } from "../../context/Context";

import RefundMainLayout from "../../pages/refund-tracker";
import RefundOrgLayout from "../../pages/refund-tracker/Organization";
import OrgRefunds from "../../pages/refund-tracker/Organization/refund";
import OrgRefundsByDepartment from "../../pages/refund-tracker/Organization/refund-by-department";
import OrgRefundsBySalesAgent from "../../pages/refund-tracker/Organization/refund-by-sales-agent";
import OrgRefundsByAccountManager from "../../pages/refund-tracker/Organization/refund-by-account-manager";
import OrgRefundsByBrand from "../../pages/refund-tracker/Organization/refund-by-brand";
import OrgRefundsByMerchant from "../../pages/refund-tracker/Organization/refund-by-merchant";
import OrgRefundsByProduct from "../../pages/refund-tracker/Organization/refund-by-product";
import OrgRefundsBySource from "../../pages/refund-tracker/Organization/refund-by-source";
import OrgRefundsByTeamLead from "../../pages/refund-tracker/Organization/refund-by-team-lead";
import OrgRefundOverview from "../../pages/refund-tracker/Organization/overview";
import ConfigLayout from "../../pages/config";
import ConfigPage from "../../pages/config/department";
import BillingMainLayout from "../../pages/billing";
import OrgRefundsMonthlyTrends from "../../pages/refund-tracker/Organization/refund-monthly-trend";
import BillingCallsLayout from "../../pages/billing/calls";
import AllCalls from "../../pages/billing/calls/all";
import BillingMeetingsLayout from "../../pages/billing/meetings";
import MyCalls from "../../pages/billing/calls/my";
import PickedCalls from "../../pages/billing/calls/picked";
import QACalls from "../../pages/billing/calls/flagged-to-qa";
import AllMeetings from "../../pages/billing/meetings/all";
import MyMeetings from "../../pages/billing/meetings/my";
import PickedMeetings from "../../pages/billing/meetings/picked";
import TranscriptDetail from "../../pages/billing/TranscriptDetail";
import OrgRefundsByQaStatus from "../../pages/refund-tracker/Organization/refund-by-qa-status";
import ManagerCalls from "../../pages/billing/calls/flagged-to-manager";
import ManagerMeetings from "../../pages/billing/meetings/flagged-to-manager";
import QAMeetings from "../../pages/billing/meetings/flagged-to-qa";
import BillingCustomerLayout from "../../pages/billing/customer";
import BillingCustomers from "../../pages/billing/customer/user";
import BillingReportsLayout from "../../pages/billing/reports";
import BillingKeyWords from "../../pages/billing/reports/keyword-stats";
import KeywordDetailsPage from "../../pages/billing/KeywordDetail";
import OrgRefundOverviewOld from "../../pages/refund-tracker/Organization/overview/index-old";


const MyRoutes = () => {
  let { state } = useContext(GlobalContext);

  const privateRoutes = [
    {
      path: "/refunds",
      element: <RefundMainLayout />,
      children: [
        // Organization
        {
          path: "organization",
          element: <RefundOrgLayout />,
          children: [
            {
              path: "overview-old",
              element: <OrgRefundOverviewOld />,
            },
            {
              path: "overview",
              element: <OrgRefundOverview />,
            },
            {
              path: "refund",
              element: <OrgRefunds />,
            },
            {
              path: "report-by-department",
              element: <OrgRefundsByDepartment />,
            },
            {
              path: "report-by-sales-agent",
              element: <OrgRefundsBySalesAgent />,
            },
            {
              path: "report-by-account-manager",
              element: <OrgRefundsByAccountManager />,
            },
            {
              path: "report-by-brand",
              element: <OrgRefundsByBrand />,
            },
            {
              path: "report-by-merchant",
              element: <OrgRefundsByMerchant />,
            },
            {
              path: "report-by-product",
              element: <OrgRefundsByProduct />,
            },
            {
              path: "report-by-source",
              element: <OrgRefundsBySource />,
            },
            {
              path: "report-by-team-lead",
              element: <OrgRefundsByTeamLead />,
            },
            {
              path: "report-monthly-trend",
              element: <OrgRefundsMonthlyTrends />,
            },
            {
              path: "report-by-qa-status",
              element: <OrgRefundsByQaStatus />,
            },
          ],
        },


      ],
    },

    {
      path: "/billing",
      element: <BillingMainLayout />,
      children: [
        // Organization
        {
          path: "calls",
          element: <BillingCallsLayout />,
          children: [
            {
              path: "all",
              element: <AllCalls />,
            },
            {
              path: "my",
              element: <MyCalls />,
            },
            {
              path: "picked",
              element: <PickedCalls />,
            },
            {
              path: "flagged-qa",
              element: <QACalls />,
            },
            {
              path: "flagged-manager",
              element: <ManagerCalls />,
            }
          ],
        },
        {
          path: "meetings",
          element: <BillingMeetingsLayout />,
          children: [
            {
              path: "all",
              element: <AllMeetings />,
            },
            {
              path: "my",
              element: <MyMeetings />,
            },
            {
              path: "picked",
              element: <PickedMeetings />,
            },
            {
              path: "flagged-qa",
              element: <QAMeetings />,
            },
            {
              path: "flagged-manager",
              element: <ManagerMeetings />,
            }
          ],
        },
        {
          path: "customers",
          element: <BillingCustomerLayout />,
          children: [
            {
              path: "customer",
              element: <BillingCustomers />,
            },

          ],
        },

        {
          path: "reports",
          element: <BillingReportsLayout />,
          children: [
            {
              path: "keywords",
              element: <BillingKeyWords />,
            },

          ],
        }


      ],
    },

    {
      path: "/config",
      element: <ConfigLayout />,
      children: [
        { path: ":type", element: <ConfigPage /> }, // generic route
      ],
    },

    {
      path: "/billing/transciptDetail/:id/:type",
      element: <TranscriptDetail />,
    },

    {
      path: "/billing/keyword-details/:id/",
      element: <KeywordDetailsPage />,
    },

    {
      path: "*",
      element: <Navigate to="/refunds/organization/overview" replace />,
    }
  ];

  const publicRoutes = [
    { path: "/login", element: <Login /> },
    { path: "*", element: <Navigate to="/login" replace /> },
  ];

  const renderRoutes = (routes) =>
    routes.map(({ path, element, index, children }, i) => (
      <Route key={i} path={path} element={element} index={index}>
        {children && renderRoutes(children)}
      </Route>
    ));

  return (
    <Routes>
      {state?.isLogin === true
        ? renderRoutes(privateRoutes)
        : state?.isLogin === false
          ? renderRoutes(publicRoutes)
          : null}
    </Routes>
  );
};

export default MyRoutes;
